import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useCampaignClone } from '../api';
import { ComposeWizard } from '../components/ComposeWizard';
import { hydrateFromClonePayload } from '../hydrate';

export function CloneVoiceCampaignPage() {
  const { campaignId } = useParams<{ campaignId: string }>();
  const id = Number(campaignId);
  const clone = useCampaignClone(id);

  const initial = useMemo(() => {
    if (!clone.data) return undefined;
    const base = hydrateFromClonePayload(clone.data);
    // Drop the original campaign name + schedule — the user picks fresh.
    return {
      ...base,
      campaignName: base.campaignName ? `${base.campaignName} (copy)` : '',
      sendLater: false,
      scheduleDate: '',
    };
  }, [clone.data]);

  if (clone.isLoading || !initial) {
    return (
      <div className="flex h-full items-center justify-center gap-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        Loading campaign…
      </div>
    );
  }

  return (
    <ComposeWizard
      mode="clone"
      initialValues={initial}
      pageTitle={`Clone Campaign #${id}`}
      pageDescription="Re-use the settings from an existing campaign and tweak as needed."
    />
  );
}
